export const blockIconsCommonactionsCalendarTodayNew = (
	<span className='material-symbols-outlined'>calendar_today</span>
);
